interface AdminUserLastLoginInput {
    isSyncedToAuth0: boolean;
    auth0LastLogin?: string | null;
}

const fullTimestampFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
});

export function formatAdminUserLastLogin(user: AdminUserLastLoginInput): string {
    if (!user.isSyncedToAuth0) {
        return '-';
    }
    if (!user.auth0LastLogin) {
        return 'Never';
    }

    const parsed = new Date(user.auth0LastLogin);
    if (Number.isNaN(parsed.getTime())) {
        return user.auth0LastLogin;
    }

    return fullTimestampFormatter.format(parsed);
}
